import { render, staticRenderFns } from "./ChooseFormTypeComponent.vue?vue&type=template&id=50f2ef97"
import script from "./ChooseFormTypeComponent.js?vue&type=script&lang=js&external"
export * from "./ChooseFormTypeComponent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports